<template>
  <div class="modal-grade pof w100 h100 t0 l0 zi100 flex aic jcc" :class="{'has-bg': background}" v-if="show">
    <div class="inner bsb lh1 tac por unselect">
      <div class="title flex aic jcc">设置年级</div>
      <div class="tip">为方便我们为您推荐合适的课程，请设置年级</div>
      <div class="ps" :class="{op0: isUpdate}">PS：进入后可再次修改</div>
      <div class="poa close grade-ico csp" @click="show = false" v-show="isUpdate"></div>
      <div class="list">
        <div class="row flex ais" v-for="(parent, i) in grades" :key="i">
          <div class="row-title">{{parent.title}}</div>
          <div class="row-list flex fww">
            <div class="col csp" @click="curr = item" :class="{active: curr === item}" v-for="(item, j) in parent.list"
                 :key="j">{{item.short_name || item.name}}
            </div>
          </div>
        </div>
      </div>
      <div class="start mlr-auto csp" @click="checked">{{isUpdate ? '确定' : '开启学习之旅'}}</div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex';

  export default {
    name: "Grade",
    computed: {
      ...mapGetters(['allGrades', 'userInfo']),
      currGrade() {
        return this.allGrades.find(e => e.id === this.userInfo.nianji_id) || {};
      },
      isUpdate() {
        return !!this.userInfo.nianji_id;
      },
    },
    props: {
      background: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        show: true,
        curr: null,
        grades: {
          1: {id: 1, title: '学前', list: []},
          2: {id: 2, title: '小学', list: []},
          3: {id: 3, title: '初中', list: []},
          4: {
            id: 4, title: '高中', list: [
              {pid: 4, short_name: '高一', name: '高一', id: 18},
              {pid: 4, short_name: '高二', name: '高二', id: 19},
              {pid: 4, short_name: '高三', name: '高三', id: 20},
            ]
          },
        },
      }
    },
    created() {
      this.getGrades().catch(this.$err);
    },
    methods: {
      ...mapMutations(['setCurrGrade', 'setAllGrades']),
      async getGrades() {
        let res = await this.GetGradeList();
        res.forEach(e => {
          let parent = this.grades[e.pid];
          if (+e.pid !== 4) {
            parent && parent.list.push(e);
          }
        });
        if (this.currGrade && this.currGrade.pid) {
          this.curr = this.grades[this.currGrade.pid].list.find(e => e.id === this.currGrade.id) || null;
        }
      },
      checked() {
        if (!this.curr) {
          return this.ShowToast('请选择年级！');
        } else if (this.curr.id !== this.currGrade.id) {
          this.$store.getters.currGrade || this.setCurrGrade(this.curr);
          this.http.NEWSetGrade({
            uid: this.userInfo.uid,
            nianji_id: this.curr.id,
            ...this.Product,
          }).catch(this.$err).finally(() => {
            this.GetUserInfoApi(this.userInfo.uid);
          });
        }
        this.$emit('select', this.curr);
        this.show = false;
      },
    },
  }
</script>

<style scoped lang="less">
  @import "../../assets/less/function";

  .op0 {
    opacity: 0 !important;
  }

  .grade-ico {
    .spirit(url(../../assets/images/user_icons.png));
    &.close {
      &:after {
        width: 28px;
        height: 27px;
        background-position: -196px -50px;
      }
    }
  }

  .has-bg {
    background-color: rgba(0, 0, 0, .3);
  }

  .inner {
    padding: 36px 78px 42px;
    width: 744px;
    min-height: 132px;
    border-radius: 8px;
    color: #fff;
    background: #fff url(../../assets/images/login/grade-bg.png) no-repeat top left / 100%;
    .title {
      margin-bottom: 12px;
      font-size: 22px;
      &:after,
      &:before {
        content: '';
        margin: 0 12px;
        width: 24px;
        height: 4px;
        border-radius: 4px;
        background-color: rgba(255, 255, 255, .8);
      }
    }
    .tip {
      margin-bottom: 22px;
      font-size: 14px;
      opacity: .8;
    }
    .ps {
      margin-bottom: 36px;
      font-size: 12px;
      opacity: .6;
    }
    .close {
      top: 12px;
      right: 12px;
      opacity: .5;
    }

    .start {
      margin-top: 36px;
      width: 400px;
      height: 40px;
      font-size: 18px;
      line-height: 40px;
      border-radius: 40px;
      background-color: #1177ff;
      &:hover {
        background-color: #0066ed;
      }
    }
    .list {
      line-height: 28px;
    }
    .row {
      &:not(:last-child) {
        margin-bottom: 24px;
      }
      .row-title {
        white-space: nowrap;
        margin-right: 16px;
        font-size: 16px;
        color: #333f4e;
      }
    }
    .col {
      width: 80px;
      height: 28px;
      font-size: 14px;
      color: #666f7a;
      background-color: #f2f2f2;
      border-radius: 28px;
      &:not(:last-child) {
        margin-right: 12px;
      }
      &.active {
        color: #fff;
        background-color: #1177ff;
      }
      &:not(.active) {
        &:hover {
          color: #1177ff;
          background-color: #e1eeff;
        }
      }
    }
  }
</style>